import React from 'react';

import * as styled from './Loader.styled';

interface ILoader {
  inverted?: boolean;
}

export const Loader: React.FC<ILoader> = ({ inverted }) => (
  <styled.Loader>
    <styled.One inverted={inverted} />
    <styled.Two inverted={inverted} />
    <styled.Three inverted={inverted} />
  </styled.Loader>
);
